import { Chat } from "./components/Chat";
import "./index.css";
import { useEffect, useState } from "react";
import { RulesClient } from "./lib/rulesClient";

import logo from "./logo.svg";
import reactLogo from "./react.svg";

export function App() {
  const [rulesClient] = useState(() => new RulesClient());
  const [rulesLoaded, setRulesLoaded] = useState(false);

  useEffect(() => {
    fetch("/api/rules")
      .then((res) => res.text())
      .then((text) => {
        if (text) {
          rulesClient.parseRules(text);
          setRulesLoaded(true);
        }
      })
      .catch((err) => console.error("Failed to load rules:", err));
  }, [rulesClient]);

  return (
    <div className="container w-full mx-auto p-8 text-center relative z-10">
      <Chat rulesClient={rulesClient} rulesLoaded={rulesLoaded} />
    </div>
  );
}

export default App;
